/**
 * 常量数值
 */
import {convertMapToOptions, sortArray} from '@/util/common'

export const EventId2023 = '1' // 2023年策略会

export const EventId2024 = '5' // 2024年策略会


// export const EventId = EventId2024 // 2024年策略会
export const EventId = '7' // 2024年策略会

/**
 * attend 不参会 0
 * @type {string}
 */
export const Attend00 = '0'
/**
 * attend 参会 1
 * @type {string}
 */
export const Attend01 = '1'
/**
 * attend 未填写信息  2
 * @type {string}
 */
export const Attend02 = '2'
/**
 * attend 不参会 0
 * @type {string}
 */
export const AttendText00 = '不参会'
/**
 * attend 参会 1
 * @type {string}
 */
export const AttendText01 = '参会'
/**
 * attend 未填写信息  2
 * @type {string}
 */
export const AttendText02 = '未填写信息'

/**
 * 参会信息 映射 attend
 * @type {{[p: string]: string}}
 */
export const AttendKeys = {
  [Attend01]: AttendText01,
  [Attend00]: AttendText00,
  [Attend02]: AttendText02
}
/**
 * 参会信息 下拉选择
 * @type {{[p: string]: string}}
 */
export const AttendOptions = sortArray(convertMapToOptions(AttendKeys), [2, 1])

/**
 * 参加晚宴 0 dinner 不参加
 * @type {string}
 */
export const Dinner00 = '0'
/**
 * 参加晚宴 1 dinner 参加
 * @type {string}
 */
export const Dinner01 = '1'
/**
 * 参加晚宴 0 dinner 不参加
 * @type {string}
 */
export const DinnerText00 = '不参加'
/**
 * 参加晚宴 1 dinner 参加
 * @type {string}
 */
export const DinnerText01 = '参加'

/**
 * 参加晚宴 dinner 映射
 * @type {string}
 */
export const DinnerKeys = {
  [Dinner01]: DinnerText01,
  [Dinner00]: DinnerText00,
}
/**
 * 参加晚宴 dinner 映射
 * @type {string}
 */
export const DinnerMap = {...DinnerKeys}
/**
 * 参加晚宴 dinner 下拉选项
 * @type {string}
 */
export const DinnerOptions = sortArray(convertMapToOptions(DinnerKeys), [2, 1])

export const Receive00 = '0'
export const Receive01 = '1'
export const ReceiveText00 = '不需要'
export const ReceiveText01 = '需要'

export const ReceiveKeys = {
  [Receive01]: ReceiveText01,
  [Receive00]: ReceiveText00,
}

export const ReceiveMap = {...ReceiveKeys}

export const ReceiveOptions = sortArray(convertMapToOptions(ReceiveKeys), [2, 1])

export const Transport01 = '1'
export const Transport02 = '2'
export const Transport03 = '3'
export const TransportText01 = '飞机'
export const TransportText02 = '高铁、火车'
export const TransportText03 = '待定'

export const TransportKeys = {
  [Transport01]: TransportText01,
  [Transport02]: TransportText02,
  [Transport03]: TransportText03
}

export const TransportOptions = convertMapToOptions(TransportKeys)

export const Station01 = '1'
export const Station02 = '2'
export const Station03 = '3'
export const Station04 = '4'
// export const Station05 = '5'

export const StationText01 = '深圳宝安机场（位于宝安区）'
export const StationText02 = '深圳北站（位于龙华区）'
export const StationText03 = '深圳站（位于罗湖区）'
// export const StationText05 = '福田站（位于福田区）'
export const StationText04 = '待定'

/**
 * todo 接送站 映射
 * @type {{[p: string]: string, "[Station01]": string, "[Station02]": string, "[Station03]": string, "[Station04]": string}}
 */
export const StationKeys = {
  [Station01]: StationText01,
  [Station02]: StationText02,
  [Station03]: StationText03,
  // [Station05]: StationText05,
  [Station04]: StationText04,
}

export const StationMap = {...StationKeys}

export const StationOptions = sortArray(convertMapToOptions(StationKeys), [1, 2, 3, 5, 4])

//住宿，1:3月17日，2:3月18日，3:3月17日、18日，0-无住宿安排
// accomodation	string	否	住宿，1:3月17日，2:3月18日，3:3月17日、18日，0-无住宿安排
/** 住宿 无住宿安排 0 */
export const Accomodation00 = '0'
/** 住宿 3.21 1 */
export const Accomodation01 = '1'
/** 住宿 3/22 2 */
export const Accomodation02 = '2'
/** 住宿 3.21 3.22  3 */
export const Accomodation03 = '3'
/** 住宿 无住宿安排  0 */
export const AccomodationText00 = '无住宿安排'
/** 住宿 3.21 1 */
export const AccomodationText01 = '3月26日（周四）'
/** 住宿 3.22  2 */
export const AccomodationText02 = '3月27日（周五）'
/** 住宿 3月21日3月22日  3 */
export const AccomodationText03 = `${AccomodationText01}、${AccomodationText02}`

/**
 * todo  住宿安排 映射
 * @type {{[p: string]: string, "[Accomodation00]": string, "[Accomodation01]": string, "[Accomodation02]": string, "[Accomodation03]": string}}
 */
export const AccomodationMap = {
  [Accomodation01]: AccomodationText01,
  [Accomodation02]: AccomodationText02,
  [Accomodation03]: AccomodationText03,
  [Accomodation00]: AccomodationText00,
}
export const AccomodationOptions = sortArray(convertMapToOptions(AccomodationMap), [4, 1, 2, 3])

/** 新增操作 1 */
export const OperationAdd = '1'
/** 编辑操作 2 */
export const OperationEdit = '2'
/** 删除操作 3 */
export const OperationDel = '3'

/**  2024/03/21  */
export const Date01 = '2026/03/26'
/**  2024/03/22  */
export const Date02 = '2026/03/27'
/**  2024/03/23  */
export const Date03 = '2026/03/23'
/**  2024/03/23  */
export const Date04 = '2026/03/28'

/**  2024年03月21日  */
export const DateText01 = '2026年03月26日'
/**  2024年03月22日  */
export const DateText02 = '2026年03月27日'
/**  2024年03月23日  */
export const DateText03 = '2026年03月23日'
/**  2026年03月15日  */
export const DateText04 = '2026年03月28日'
export const DateTextMode = '2026年03月25日';
export const DateTextModeVal = '2026/03/25';

export const DateMap = {
  [DateTextModeVal]: DateTextMode,
  [Date01]: DateText01,
  [Date02]: DateText02,
  [Date03]: DateText03,
  [Date04]: DateText04,
}
export const DateTextMap = Object.entries(DateMap).reduce((acc, [key, value]) => {
  acc[value] = key;
  return acc;
}, {});
export const DateOptions = sortArray(convertMapToOptions(DateMap), [1, 2, 3])

export const ReceiveDateOptions = DateOptions.filter(item => item.value !== Date03)
export const SendDateOptions = DateOptions.filter(item => item.value !== Date01)

// startH 开始时间   endH 结束时间
const timeList = (startH = 0, endH = 24) => {
  const list = Array.from({length: 24}, (_, i) => i < 10 ? `0${i}` : `${i}`).map((hour, index) => {
    let children = Array.from({length: 12}, (_, i) => i * 5 < 10 ? `0${i * 5}` : `${i * 5}`).map((min) => {
      return { text: min, hIndex: index }
    });

    if (index === endH) {
      children = [
        {
          text: '00',
          hIndex: index,
        }
      ]
    }

    return {
      text: hour,
      hIndex: index,
      children,
    }
  }).filter(item => (item.hIndex <= endH && item.hIndex >= startH));
  return list;
}

/**
 * 接机时间限制 根据 选择的住宿时间 有不同的 时间范围
 * （1）如果选择3.21号住宿，接机时间仅可选3月21日00:00到3.22早上7点之前，送机时间3.22早上12点到3月23日24:00；

 （2）如果选择3.22号住宿，接机时间仅可选3月21日00:00到3.22晚上20点之前，送机时间3月23日0:00到3月23日24:00；

 （3）如果选择3.21-22住宿，接机时间仅可选3月21日00:00到3.22早上7点之前，送机时间3月23日0:00到3月23日24:00；

 （4）如果选了不住宿，到达接机时间为3月21日00:00-3月22日12:00，酒店送机时间为3月22日12:00-3月23日24:00；
 * @type {{[p: string]: [{children: {children: {text: string}[], text: string}[], text: string}, {children: {children: {disabled, text: string}[], disabled: boolean, text: string}[], text: string}]|[{children: {children: {text: string}[], text: string}[], text: string}, {children: {children: {disabled, text: string}[], disabled: boolean, text: string}[], text: string}]|[{children: {children: {text: string}[], text: string}[], text: string}, {children: {children: {disabled, text: string}[], disabled: boolean, text: string}[], text: string}]|[{children: {children: {text: string}[], text: string}[], text: string}, {children: {children: {disabled, text: string}[], disabled: boolean, text: string}[], text: string}], "[Accomodation00]": [{children: {children: {text: string}[], text: string}[], text: string}, {children: {children: {disabled, text: string}[], disabled: boolean, text: string}[], text: string}], "[Accomodation01]": [{children: {children: {text: string}[], text: string}[], text: string}, {children: {children: {disabled, text: string}[], disabled: boolean, text: string}[], text: string}], "[Accomodation02]": [{children: {children: {text: string}[], text: string}[], text: string}, {children: {children: {disabled, text: string}[], disabled: boolean, text: string}[], text: string}], "[Accomodation03]": [{children: {children: {text: string}[], text: string}[], text: string}, {children: {children: {disabled, text: string}[], disabled: boolean, text: string}[], text: string}]}}
 */
export const ReceiveDateRange = {
  // （1）如果选择3.13号住宿，接机时间仅可选3月13日00:00到3.14早上7点之前；
  [Accomodation01]: [
    {
      text: DateTextMode,
      value: DateTextModeVal,
      children: timeList(),
    },
    {
      text: DateText01,
      value: Date01,
      children: timeList(),
    },
    {
      text: DateText02,
      value: Date02,
      children: timeList(0, 7),
    },
  ],
  // （2）如果选择3.14号住宿，接机时间仅可选3月14日00:00到3.14晚上20点之前；
  [Accomodation02]: [
    {
      text: DateText02,
      value: Date02,
      children: timeList(0, 20),
    },
    // {
    //   text: DateText02,
    //   children: Array.from({length: 24}, (_, i) => i < 10 ? `0${i}` : `${i}`).map((hour, index) => {
    //     return {
    //       text: hour,
    //       disabled: index > 20,
    //       children: Array.from({length: 12}, (_, i) => i * 5 < 10 ? `0${i * 5}` : `${i * 5}`).map((min) => {
    //         return {text: min, disabled: index > 20 || (index === 20 && min !== '00')}
    //       })
    //     }
    //   })
    // },
  ],
  // （3）如果选择3.13-14住宿，接机时间仅可选3月13日00:00到3.14早上7点之前；
  [Accomodation03]: [
    {
      text: DateTextMode,
      value: DateTextModeVal,
      children: timeList(),
    },
    {
      text: DateText01,
      value: Date01,
      children: timeList(),
    },
    {
      text: DateText02,
      value: Date02,
      children: timeList(0, 7),
    },
  ],
  // （4）如果选了不住宿，到达接机时间为3月13日00:00-3月14日12:00；
  [Accomodation00]: [
    {
      text: DateText01,
      value: Date01,
      children: timeList(),
    },
    {
      text: DateText02,
      value: Date02,
      children: timeList(0, 12),
    },
  ]
}
/**
 * 送机时间限制 根据 选择的住宿时间 有不同的 时间范围
 * （1）如果选择3.21号住宿，接机时间仅可选3月21日00:00到3.22早上7点之前，送机时间3.22早上12点到3月23日24:00；

 （2）如果选择3.22号住宿，接机时间仅可选3月21日00:00到3.22晚上20点之前，送机时间3月23日0:00到3月23日24:00；

 （3）如果选择3.21-22住宿，接机时间仅可选3月21日00:00到3.22早上7点之前，送机时间3月23日0:00到3月23日24:00；

 （4）如果选了不住宿，到达接机时间为3月21日00:00-3月22日12:00，酒店送机时间为3月22日12:00-3月23日24:00；
 * @type {{[p: string]: [{children: {children: {text: string}[], text: string}[], text: string}, {children: {children: {disabled, text: string}[], disabled: boolean, text: string}[], text: string}]|[{children: {children: {text: string}[], text: string}[], text: string}, {children: {children: {disabled, text: string}[], disabled: boolean, text: string}[], text: string}]|[{children: {children: {text: string}[], text: string}[], text: string}, {children: {children: {disabled, text: string}[], disabled: boolean, text: string}[], text: string}]|[{children: {children: {text: string}[], text: string}[], text: string}, {children: {children: {disabled, text: string}[], disabled: boolean, text: string}[], text: string}], "[Accomodation00]": [{children: {children: {text: string}[], text: string}[], text: string}, {children: {children: {disabled, text: string}[], disabled: boolean, text: string}[], text: string}], "[Accomodation01]": [{children: {children: {text: string}[], text: string}[], text: string}, {children: {children: {disabled, text: string}[], disabled: boolean, text: string}[], text: string}], "[Accomodation02]": [{children: {children: {text: string}[], text: string}[], text: string}, {children: {children: {disabled, text: string}[], disabled: boolean, text: string}[], text: string}], "[Accomodation03]": [{children: {children: {text: string}[], text: string}[], text: string}, {children: {children: {disabled, text: string}[], disabled: boolean, text: string}[], text: string}]}}
 */
export const SendDateRange = {
  // （1）如果选择3.13号住宿，接机时间仅可选3月13日00:00到3.14早上7点之前；送机时间3月14日早上12点到3月15日24:00；
  [Accomodation01]: [
    {
      text: DateText02,
      value: Date02,
      children: timeList(10, 24),
    },
    // {
    //   text: DateText04,
    //   children: timeList(),
    // },
  ],
  // （2）如果选择3.14号住宿，接机时间仅可选3月14日00:00到3.14晚上20点之前；送机时间3月15日0:00到3月15日24:00；
  [Accomodation02]: [
    {
      text: DateText04,
      value: Date04,
      children: timeList(),
    },
  ],
  // （3）如果选择3.13-14住宿，接机时间仅可选3月13日00:00到3.14早上7点之前；送机时间3月15日0:00到3月15日24:00；
  [Accomodation03]: [
    {
      text: DateText04,      
      value: Date04,
      children: timeList(),
    },
  ],
  // （4）如果选了不住宿，到达接机时间为3月13日00:00-3月14日12:00；酒店送机时间为3月14日12:00-3月15日24:00；
  [Accomodation00]: [
    {
      text: DateText02,
      value: Date02,
      children: timeList(12, 24),
    },
    {
      text: DateText04,
      value: Date04,
      children: timeList(),
    },
  ],
}



/**
 * todo 常量合集
 */
export default {
  EventId2024, EventId,
  OperationAdd,
  OperationEdit,
  OperationDel,
  AccomodationMap,
  AccomodationOptions,
  Accomodation00,
  Accomodation01,
  Accomodation02,
  Accomodation03,
  AccomodationText00,
  AccomodationText01,
  AccomodationText02,
  AccomodationText03,
  Station01, Station02, Station03, Station04,
  StationText01, StationText02, StationText03, StationText04,
  StationKeys, StationOptions,
  TransportOptions,
  TransportKeys,
  Transport01,
  Transport02,
  Transport03,
  TransportText01,
  TransportText02,
  TransportText03,
  ReceiveOptions,
  ReceiveKeys,
  Receive01,
  Receive00,
  ReceiveText00,
  ReceiveText01,
  DinnerOptions,
  DinnerKeys,
  Dinner00,
  Dinner01,
  DinnerText00,
  DinnerText01,
  AttendOptions,
  AttendKeys,
  Attend00,
  Attend01,
  Attend02,
  AttendText00,
  AttendText01,
  AttendText02,
  DateMap,
  DateOptions,
  ReceiveDateOptions,
  SendDateOptions,
  DateTextMap,
  ReceiveDateRange,
  SendDateRange,
  DateText02
}
